import { useCallback, useState } from 'react';
import useCallbackRef from './useCallbackRef';
import {
  DownloadBannerContentProps,
  DownloadBannerPayload,
  DownloadBannerStatus,
  DownloadBannerType,
  DOWNLOAD_BANNER_TYPE,
} from 'models/Download';
import { DownloadStatusBannerRef } from 'components/DownloadStatusBanner/DownloadStatusBanner.component';

export default function useDownloadBanner() {
  const [downloadStatus, setDownloadStatus] =
    useState<DownloadBannerStatus>(null);

  const [downloadType, setDownloadType] = useState<DownloadBannerType>(
    DOWNLOAD_BANNER_TYPE.FILE,
  );

  const [downloadBannerProps, setDownloadBannerProps] =
    useState<DownloadBannerContentProps>({});

  const [downloadBanner, downloadBannerRef] =
    useCallbackRef<DownloadStatusBannerRef>();

  const showDownloadBanner = useCallback(
    (payload: DownloadBannerPayload) => {
      const { status, type, ...bannerProps } = payload || {};

      setDownloadStatus(status);
      setDownloadType(type || DOWNLOAD_BANNER_TYPE.FILE);
      setDownloadBannerProps(bannerProps);

      if (status) downloadBanner?.open();
      else downloadBanner?.close();
    },
    [downloadBanner],
  );

  return {
    downloadStatus,
    downloadType,
    downloadBannerProps,
    downloadBannerRef,
    showDownloadBanner,
  };
}
